/* eslint-disable no-param-reassign */
import { getAge } from '../../utils';
import { FILTER_BY_CONTROL, FILTER_BY_PROFILE, MARK_ITEMS_FOR_CURRENT_PROFILE } from '../store/serviceSlice';

const debug = false;

export const getPlainObject = obj => JSON.parse(JSON.stringify(obj));
// eslint-disable-next-line no-console
const message = (msg, values) => debug && console.log(msg, values ? getPlainObject(values) : values);

export const getSortedPriorityList = priority => Object.entries(priority)
    .sort(([ , v1 ], [ , v2 ]) => {
        return v1 - v2;
    })
    .map(([k]) => k);

export const sortListByName = (a, b) => {
    const aName = a.name;
    const bName = b.name;
    if (aName > bName) {
        return 1;
    }
    if (aName < bName) {
        return -1;
    }
    return 0;
};

export const isServiceForAge = ({
    forAdult,
    forChildren,
    childrenAge,
    childrenAgeTo,
    age,
}) => {
    if (age > 17) {
        return forAdult;
    }
    if (forChildren) {
        const minAge = childrenAge !== undefined && childrenAge !== null ? childrenAge : 0;
        const maxAge = childrenAgeTo !== undefined && childrenAgeTo !== null ? childrenAgeTo : 18;
        return age >= minAge && age <= maxAge;
    }
    return false;
};

export const isServiceForProfile = ({
    serviceForChild,
    serviceForAdult,
    serviceAge,
    serviceAgeTo,
    age,
    child,
}) => {
    if (Number(age) === -1 && child) {
        return serviceForChild;
    }

    if (age === undefined || age === null || Number.isNaN(age) || (age === -1 && !child)) {
        return true;
    }
    return isServiceForAge({
        forAdult: serviceForAdult,
        forChildren: serviceForChild,
        childrenAge: serviceAge,
        childrenAgeTo: serviceAgeTo,
        age,
    });
};

const isServicePassed = ({
    forChildren,
    forAdult,
    childrenAge,
    childrenAgeTo,
    age,
    onlyForChild,
}) => {
    if (FILTER_BY_PROFILE || FILTER_BY_CONTROL) {
        if (Number(age) === -1 && onlyForChild) {
            return forChildren;
        }
        if (age === undefined || age === null || Number.isNaN(age) || (age === -1 && !onlyForChild)) {
            return true;
        }
        if (!onlyForChild && FILTER_BY_CONTROL) {
            return true;
        }
        return isServiceForAge({
            forAdult,
            forChildren,
            age,
            childrenAge,
            childrenAgeTo,
        });
    }
    return true;
};

export const getBranchListBySelectedService = (state) => {
    const {
        doctors = [],
        branches = [],
        selectedProfile,
    } = state;
    const age = getAge(selectedProfile?.birthday ?? Date.now());
    const { services } = state?.selected ?? '';

    const branchList = [];
    doctors?.forEach((doctor) => {
        const {
            children: forChildren,
            adult: forAdult,
            children_age: childrenAge,
            children_age_to: childrenAgeTo,
        } = doctor;
        if (
            !isServicePassed({
                age,
                forAdult,
                forChildren,
                childrenAge,
                childrenAgeTo,
                onlyForChild: state.forChildren,
            })
        ) {
            return;
        }
        doctor?.worksAt?.some((work) => {
            if (branchList.includes(work?.branchId)) {
                return false;
            }
            if (work?.serviceMappings?.some(({ serviceId }) => serviceId === services)) {
                branchList.push(work?.branchId);
            }
            return false;
        });
    });
    return branches.filter(({ id }) => branchList.includes(id));
};

export const getDataByDirection = (data, directionId) => {
    return data.filter(({ id }) => id === directionId);
};

export const getDataBySubgroup = (data, subGroupId) => {
    const res = [];
    data.forEach((direction) => {
        const dir = {
            id: direction.id,
            name: direction.name,
            subGroups: [],
        };

        direction.subGroups.forEach((subGroup) => {
            if (subGroup?.id === subGroupId) {
                if (FILTER_BY_CONTROL) {
                    if (subGroup?.hidden && subGroup?.forProfile === false) {
                        return;
                    }
                }
                dir.subGroups.push({
                    ...subGroup,
                    parentId: direction?.id,
                });
            }
        });

        res.push(dir);
    });
    return res;
};

export const getDataByBranch = (data) => {
    return data;
};

export const getDataByService = (data, serviceId) => {
    const subGroupHasService = (district, s) => !!district?.services.find(service => service?.id === s);

    const res = [];
    data.forEach((direction) => {
        const dir = {
            id: direction.id,
            name: direction.name,
        };
        dir.subGroups = [];
        direction.subGroups.forEach((subGroup) => {
            if (subGroupHasService(subGroup, serviceId)) {
                dir.subGroups.push({
                    ...subGroup,
                    parentId: direction.id,
                });
            }
        });
        res.push(dir);
    });
    return res;
};

export const getParentServiceInfo = (data, serviceId) => {
    const res = {
        directions: undefined,
        subGroups: undefined,
    };
    let found = false;
    data.some(({
        id,
        subGroups,
    }) => {
        res.directions = id;
        subGroups.some((subGroup) => {
            res.subGroups = subGroup?.id;
            subGroup?.services?.some?.((service) => {
                if (service?.id === serviceId) {
                    found = true;
                    return true;
                }
                return false;
            });
            return found;
        });
        return found;
    });
    if (!found) {
        res.directions = undefined;
        res.subGroups = undefined;
    }
    message('getParentServiceInfo', {
        found,
        res,
    });
    return res;
};

export const getParentSubGroupInfo = (data, districtId) => {
    const res = { directions: undefined };
    let found = false;
    data.some(({
        id,
        subGroups,
    }) => {
        res.directions = id;
        subGroups.some((subGroup) => {
            if (districtId === subGroup?.id) {
                found = true;
                return true;
            }
            return false;
        });
        return found;
    });
    if (!found) {
        res.directions = undefined;
    }
    message('getParentSubGroupInfo', {
        districtId,
        res,
    });
    return res;
};

export const getBranchList = (data, branches = []) => {
    return branches.sort(sortListByName);
};

export const getDirectionList = (data) => {
    const result = data
        .map(({
            id,
            name,
            code,
            forProfile,
            hasDoctors,
            hidden,
        }) => ({
            id,
            name,
            code,
            forProfile,
            hasDoctors,
            hidden,
        }))
        .sort(sortListByName);
    if (FILTER_BY_CONTROL) {
        return result.filter(({
            forProfile,
            hasDoctors,
            hidden,
        }) => forProfile && hasDoctors && !hidden);
    }
    return result;
};

export const getSubGroupList = (data) => {
    const list = [];
    try {
        data.forEach(({
            subGroups,
            id: parentId,
        }) => subGroups.forEach(({
            id,
            name,
            code,
            description,
            forProfile,
            hasDoctors,
            hidden,
        }) => {
            if ((FILTER_BY_PROFILE || FILTER_BY_CONTROL) && (!forProfile || hidden)) {
                return;
            }
            !!hasDoctors &&
            list.push({
                id,
                name,
                code,
                description,
                parentId,
                forProfile,
                hasDoctors,
                hidden,
            });
        }));
    } catch (e) {
        // eslint-disable-next-line no-console
        console.log('Error get subgroup list', e);
    }
    return list.sort(sortListByName);
};

export const getServiceList = (data, checkOnlyHidden = false) => {
    const list = [];
    // const age = FILTER_BY_PROFILE ? getAge(profile?.birthday) : FILTER_BY_CONTROL ? state?.childrenAge : 0;
    try {
        data.forEach(({ subGroups }) => subGroups.forEach(({
            services,
            id: parentId,
        }) => services.forEach(
            ({
                id,
                name,
                description,
                code,
                forAdult,
                forChildren,
                childrenAge,
                childrenAgeTo,
                forProfile,
                hasDoctors,
                hidden,
                price,
            }) => {
                if (
                    (FILTER_BY_PROFILE || FILTER_BY_CONTROL) &&
                    ((!forProfile && !checkOnlyHidden) || hidden)
                    // !isServiceForAge({
                    //     childrenAge,
                    //     childrenAgeTo,
                    //     forChildren,
                    //     forAdult,
                    //     age,
                    // })
                ) {
                    return;
                }
                (!!hasDoctors || checkOnlyHidden) &&
                list.push({
                    id,
                    name,
                    description,
                    code,
                    forAdult,
                    forChildren,
                    childrenAge,
                    childrenAgeTo,
                    parentId,
                    forProfile,
                    hasDoctors,
                    hidden,
                    price,
                });
            },
        )));
    } catch (e) {
        // eslint-disable-next-line no-console
        console.log('Error get service list', e);
    }
    return list.sort(sortListByName);
};

const getListFn = {
    services: getServiceList,
    branches: getBranchList,
    directions: getDirectionList,
    subGroups: getSubGroupList,
};

const getDataFn = {
    services: (...p) => {
        message('getDataByService', p);
        const temp = getDataByService(...p);
        message('result', temp);
        return temp;
    },
    branches: (...p) => {
        message('getDataByBranch', p);
        const temp = getDataByBranch(...p);
        message('result', temp);
        return temp;
    },
    subGroups: (...p) => {
        message('getDataBySubgroup', p);
        const temp = getDataBySubgroup(...p);
        message('result', temp);
        return temp;
    },
    directions: (...p) => {
        message('getDataByDirection', p);
        const temp = getDataByDirection(...p);
        message('result', temp);
        return temp;
    },
};

const getDataLengthByService = (data, serviceId) => {
    let res = 0;
    data.forEach((direction) => {
        direction.subGroups.forEach((subGroup) => {
            subGroup?.services?.forEach(({ id }) => {
                res += serviceId === id ? 1 : 0;
            });
        });
    });
    return res;
};
const getDataLengthBySubGroup = (data, subGroupId) => {
    let res = 0;
    data.forEach((direction) => {
        direction.subGroups.forEach((subGroup) => {
            if (subGroup?.id === subGroupId) {
                if (FILTER_BY_CONTROL) {
                    if (subGroup?.hidden && subGroup?.forProfile === false) {
                        return;
                    }
                }
                res++;
            }
        });
    });
    return res;
};
const getDataLengthByBranch = () => {
};
const getDataLengthByDirection = (data, directionId) => data?.filter(({ id }) => id === directionId)?.length ?? 0;

const getDataLengthFn = {
    services: (...p) => {
        message('getDataByService', p);
        const temp = getDataLengthByService(...p);
        message('result', temp);
        return temp;
    },
    branches: (...p) => {
        message('getDataByBranch', p);
        const temp = getDataLengthByBranch(...p);
        message('result', temp);
        return temp;
    },
    subGroups: (...p) => {
        message('getDataBySubgroup', p);
        const temp = getDataLengthBySubGroup(...p);
        message('result', temp);
        return temp;
    },
    directions: (...p) => {
        message('getDataByDirection', p);
        const temp = getDataLengthByDirection(...p);
        message('result', temp);
        return temp;
    },
};

const fillServiceDataForProfile = (data, profile, doctors = [], forChild, forChildAge) => {
    const age = forChildAge ?? getAge(profile?.birthday);
    data?.forEach((direction) => {
        let profileForDirection = false;
        let hasDoctorsForDirection = false;
        let dirHidden = true;
        direction?.subGroups.forEach((subGroup) => {
            let profileForSubGroup = false;
            let hasDoctorsForSubGroup = false;
            let hidden = true;
            subGroup?.services.forEach((service) => {
                const forProfile = isServicePassed({
                    forAdult: service?.forAdult,
                    forChildren: service.forChildren,
                    childrenAge: service.childrenAge,
                    childrenAgeTo: service.childrenAgeTo,
                    age,
                    onlyForChild: forChild,
                });
                const hasDoctors =
                    doctors?.some?.(({ worksAt }) => worksAt?.some(({ serviceMappings }) => serviceMappings?.find?.(({ serviceId }) => serviceId === service?.id))) || !doctors?.length;
                if (forProfile) {
                    profileForSubGroup = true;
                }
                if (hasDoctors) {
                    hasDoctorsForSubGroup = true;
                }

                service.hidden = !forProfile || !hasDoctors;
                service.forProfile = forProfile;
                service.hasDoctors = hasDoctors;
                if (hidden) {
                    if (hasDoctors && forProfile) {
                        hidden = false;
                    }
                }
            });
            subGroup.forProfile = profileForSubGroup;
            subGroup.hasDoctors = hasDoctorsForSubGroup;
            subGroup.hidden = hidden;
            if (profileForSubGroup) {
                profileForDirection = true;
            }
            if (hasDoctorsForSubGroup) {
                hasDoctorsForDirection = true;
            }
            if (dirHidden) {
                if (profileForDirection && hasDoctorsForDirection && !hidden) {
                    dirHidden = false;
                }
            }
        });
        direction.hidden = dirHidden;
        direction.forProfile = profileForDirection;
        direction.hasDoctors = hasDoctorsForDirection;
    });
    return data;
};

export const createFilterValues = ({
    priority,
    data,
    exclude,
    selection,
    branches,
    profile,
    doctors,
    age = 18,
    forChild,
    withoutAutoselect,
}) => {
    message('createFilterValues', {
        priority,
        branches,
    });
    const result = {
        filter: {},
        selectedData: data,
    };

    const selected = {};

    let tempData = getPlainObject([
        ...(MARK_ITEMS_FOR_CURRENT_PROFILE
            ? fillServiceDataForProfile(getPlainObject(data), profile, doctors, forChild, age)
            : data),
    ]);

    priority.forEach((item) => {
        let priorityValue = selection?.[item];
        message('   Priority value', {
            priorityValue,
            item,
        });
        if (exclude?.length && exclude.includes(item)) {
            return;
        }
        const filterData = getListFn?.[item]?.(tempData, item === 'services' ? profile : branches) ?? [];
        if (!withoutAutoselect && filterData?.length === 1 && !priorityValue) {
            priorityValue = filterData[0]?.id;
            selection[item] = priorityValue;
        }
        if (!priorityValue) {
            return;
        }
        result.filter[item] = filterData;
        message('      result', result.filter[item]);
        const t = [...(getDataFn?.[item]?.(tempData, priorityValue) ?? [])];
        if (getDataLengthFn[item](tempData, priorityValue)) {
            tempData = t;
        }
        message('     tempData', tempData);
        selected[item] = true;
    });
    selected.service = true;
    priority.forEach((item) => {
        if (selected[item]) {
            return;
        }
        result.filter[item] = getListFn?.[item]?.(tempData, item === 'services' ? profile : branches);
    });
    result.selectedData = tempData;
    message(' === set filter ===', result);
    return result;
};

export const checkSelectionInState = (sourceState) => {
    const state = { ...sourceState };
    const {
        filter,
        selected,
    } = state;
    if (selected?.services) {
        if (!filter?.services?.find(item => item?.id === selected?.services)) {
            selected.services = null;
        }
    }
    if (selected?.directions) {
        if (!filter?.directions?.find(item => item?.id === selected?.directions)) {
            selected.directions = null;
        }
    }
    if (selected?.subGroups) {
        if (!filter?.subGroups?.find(item => item?.id === selected?.subGroups)) {
            selected.subGroups = null;
        }
    }
    return selected;
};

export const getSelectedItemByName = (items, itemName) => {
    if (!items || !itemName) {
        return null;
    }
    const normalizedItemName = itemName.trim().toLowerCase();
    const itemMap = new Map(
        items.map(item => [ item.name.trim().toLowerCase(), item ]),
    );
    return itemMap.get(normalizedItemName) || null;
};

export const getSelectedItemIdByName = (items, itemName) => {
    const selectedItem = getSelectedItemByName(items, itemName);
    return selectedItem ? selectedItem.id : null;
};
